import { Component } from '@angular/core';
import { ClinicOfficeManageService } from 'src/shop-manager/services/clinic-office-manage.service';
import { BehaviorSubject, first } from 'rxjs';
import { RequestedClinicHistoryItemJSON } from 'src/shop-manager/common/models/server-response/requested-clinic-history-item-json.model';
import { RequestedOfficeHistoryItemJSON } from 'src/shop-manager/common/models/server-response/requested-office-history-item-json.model';
import { ServerValueInterpreterService } from 'src/common-panel/services/server-value-interpreter.service';
import { ShopTypesEnum } from 'src/common-panel/enums/shop-types-enum';
import { BrandTypesEnum } from 'src/common-panel/enums/brand-types-enum';
@Component({
    selector: 'app-history-log-dialog',
    templateUrl: './history-log-dialog.component.html',
    styleUrls: ['./history-log-dialog.component.css'],
    standalone: false
})
export class HistoryLogDialogComponent
{
  logClinicSubject: BehaviorSubject<RequestedClinicHistoryItemJSON|undefined> = new BehaviorSubject<RequestedClinicHistoryItemJSON|undefined>(undefined)
  logOfficeSubject: BehaviorSubject<RequestedOfficeHistoryItemJSON|undefined> = new BehaviorSubject<RequestedOfficeHistoryItemJSON|undefined>(undefined)

  loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

  isENT: boolean = false

  constructor(private clinicOfficeManageService: ClinicOfficeManageService, private serverValueInterpreterService:ServerValueInterpreterService)
  {
    this.loadingSubject.next(true)
    this.clinicOfficeManageService.loadLog().pipe(first(val => val == true)).subscribe(() =>
    {
      if (this.clinicOfficeManageService.currentClinicOffice?.type1 == ShopTypesEnum.clinic) this.logClinicSubject.next(this.clinicOfficeManageService.clinicLog)
      else if (this.clinicOfficeManageService.currentClinicOffice?.type1 == ShopTypesEnum.entOffice)
      {
        this.isENT = true
        this.logOfficeSubject.next(this.clinicOfficeManageService.officeLog)
      }
      this.loadingSubject.next(false)
    })

  }

  getStateName(state: string): string
  {
    return this.serverValueInterpreterService.getStateName(state);
  }

  getBrandName(brandId: BrandTypesEnum|string): string
  {
    return this.serverValueInterpreterService.getBrandName(brandId as BrandTypesEnum)
  }
}
